/**
 * Algolia Client
 * Initialize Algolia search client and index
 */

const defaults = window.CampsUtils?.defaults || {};

const ALGOLIA_APP_ID = defaults.algoliaAppId;
const ALGOLIA_SEARCH_KEY = defaults.algoliaSearchKey;
const ALGOLIA_INDEX_NAME = defaults.algoliaIndex;

let searchClient = null;
let index = null;

/**
 * Initialize Algolia client
 */
function initClient() {
  if (searchClient) return;

  if (!ALGOLIA_APP_ID || !ALGOLIA_SEARCH_KEY || !ALGOLIA_INDEX_NAME) {
    console.error('Missing Algolia credentials');
    return;
  }

  searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
  index = searchClient.initIndex(ALGOLIA_INDEX_NAME);

  console.log('✅ Algolia client initialized');
}

// Initialize on module load
initClient();

/**
 * Get Algolia client
 * @returns {Object}
 */
export function getClient() {
  if (!searchClient) initClient();
  return searchClient;
}

/**
 * Get Algolia index
 * @returns {Object}
 */
export function getIndex() {
  if (!index) initClient();
  return index;
}

console.log('📦 Algolia client module loaded');
